import React from "react";

export function Loading() {

    return (
        <div className={"loading"}>
            <img src={"/images/loading.gif"} alt={"loading"}/>
        </div>
    );
}
